<nav class="navbar-dark bg-dark fixed-bottom">
  <span class="navbar-text">
    &nbsp; {{version}} (Server: {{serverVersion}}
    <!-- -
    <span
      [ngClass]="connectionState.class">{{connectionState.label}}</span> -->
    )
  </span>
  <span class="dot"></span>
</nav>
